// extracted by mini-css-extract-plugin
export default {"main":"register_main__zZL+f","_header":"register__header__RetaW","_body":"register__body__mj7o5"};